import React from 'react';
export type TransactionStatusTabType = 'all' | 'REQUESTED' | 'APPROVED' | 'PAID';

export type TransactionStatusTabListType = {
  text: string;
  value: TransactionStatusTabType;
  className?: string;
  onClick?: () => void;
};
const TransactionStatusTab = ({
  active,
  setActive,
  list
}: {
  active: TransactionStatusTabType;
  setActive: (item: TransactionStatusTabType) => void;
  list: TransactionStatusTabListType[];
}) => {
  return (
    <div className='flex my-3 bg-[#F7F7F8] rounded-md w-auto'>
      {list.map(({ text, value, className, onClick }) => (
        <div
          key={value}
          className={`cursor-pointer text-sm border-none py-[7px] px-3 text-center font-medium ${className}`}
          onClick={() => {
            setActive(value);
            onClick?.();
          }}>
          <p
            className={`rounded-md px-3 ${
              active !== value ? 'text-gray-9 bg-none' : 'bg-white text-red-5'
            } `}>
            {text}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TransactionStatusTab;
